import { Box, Paper, Typography } from "@mui/material";
import { buildAdmissionValuesFromStudent } from "../../Accounts/accountUtils";

export const getManageAdmissionContext = (student, appInfo = {}, courseList = [], uniData = []) => {
  if (!student) {
    return { shortTabLabel: "Admission", fields: [] };
  }
  const resolved = buildAdmissionValuesFromStudent({
    student,
    courseList,
    uniData,
  });
  const university = resolved.university || "";
  const course = resolved.course || "";
  const institutionStudentId = resolved.studentId || appInfo?.studentId || student?.studentId || "";
  const intake = resolved.intake || appInfo?.intake || student?.intake || "";

  const fields = [
    { label: "University", value: university },
    { label: "Course", value: course },
    { label: "Student ID", value: institutionStudentId },
    { label: "Intake", value: intake },
  ].filter((f) => f.value);

  const shortTabLabel = [student.name || "Admission", intake].filter(Boolean).join(" · ");

  return { shortTabLabel, fields };
};

const fieldGridSx = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
  gap: 2,
};

const FieldItem = ({ label, value }) => (
  <Box>
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ display: "block", mb: 0.5, fontWeight: 600, letterSpacing: 0.3 }}
    >
      {label}
    </Typography>
    <Typography variant="body2" sx={{ fontWeight: 600, color: "text.primary", lineHeight: 1.4 }}>
      {value}
    </Typography>
  </Box>
);

export const ManageAdmissionContextPanel = ({ context, sx }) => {
  if (!context?.fields?.length) return null;
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2.5,
        mb: 1,
        bgcolor: "var(--app-surface-alt)",
        borderColor: "var(--app-border)",
        borderRadius: 2,
        ...sx,
      }}
    >
      <Typography
        variant="overline"
        sx={{
          display: "block",
          mb: 1.5,
          color: "var(--app-text-secondary)",
          fontWeight: 700,
          letterSpacing: 1,
          lineHeight: 1.2,
        }}
      >
        Admission details
      </Typography>
      <Box sx={fieldGridSx}>
        {context.fields.map(({ label, value }) => (
          <FieldItem key={label} label={label} value={value} />
        ))}
      </Box>
    </Paper>
  );
};

export const ManageAdmissionContextTooltip = ({ context }) => {
  if (!context?.fields?.length) return null;
  return (
    <Box sx={{ p: 0.5, minWidth: 240, maxWidth: 320 }}>
      <Typography
        variant="caption"
        sx={{
          display: "block",
          mb: 1,
          color: "var(--app-text-muted)",
          fontWeight: 700,
          letterSpacing: 0.8,
          textTransform: "uppercase",
        }}
      >
        Admission details
      </Typography>
      <Box sx={{ ...fieldGridSx, gap: 1.25 }}>
        {context.fields.map(({ label, value }) => (
          <FieldItem key={label} label={label} value={value} />
        ))}
      </Box>
    </Box>
  );
};

export const manageAdmissionTabTooltipProps = {
  placement: "top",
  arrow: true,
  enterDelay: 400,
  disableInteractive: true,
  describeChild: true,
  componentsProps: {
    tooltip: {
      sx: {
        bgcolor: "var(--app-surface)",
        color: "text.primary",
        boxShadow: "0 8px 24px rgba(15, 23, 42, 0.12)",
        border: "1px solid #e2e8f0",
        borderRadius: 2,
        p: 1.5,
        maxWidth: 360,
      },
    },
    arrow: {
      sx: {
        color: "#ffffff",
        "&::before": {
          border: "1px solid #e2e8f0",
        },
      },
    },
  },
};
